import './_input-radio.scss';
import './_input-radio.twig';
import $ from 'jquery';

export const name = 'input-radio';

export function disable() {}

export function enable(dom) {
  var $dom = $(dom);
  var $target = $dom.find('.js-form-type-radios, .js-form-type-webform-radios-other, .js-webform-type-radios, .js-webform-type-webform-radios-other');
  if ($target.length > 0) {
    /**
     * web/modules/contrib/webform/js/webform.states.js:toggleRequired sets the "required" attribute via JS
     * we don't want it
     * @see web/themes/particle/apps/drupal/templates/form/input.html.twig
     */
    setTimeout(function(){
      $target.find('input[type="radio"]').removeAttr('required aria-required');
    }, 10)
  }
}

export default enable;
